import React from 'react'

function ProjectAdminEdit() {
  return (
    <div>ProjectAdminEdit</div>
  )
}

export default ProjectAdminEdit